export default __webpack_public_path__ + "./images/bd.557aa5bc.png";